import { useCallback, useState } from "react";
import Form from 'react-bootstrap/Form';
import { InstapayCollectionMethods, PaymentMethodType } from "../../../common/constans";
import Collapse from 'react-bootstrap/Collapse';
import ApiClient from "../../../ApiClient";
import useDeviceType from "../../../hooks/device-detect";
import PoweredByBox from "../../../common/poweredByBox";
import InstapayQrCode from "./QrCode";
import PaymentLink from "./PaymentLink";
import CollectRequest from "./CollectRequest";

const InstapayPaymentForm = ({ payment_session_info, onChangeTapsVisiability }) => {
    const { getAuthenticationView, getAuthenticationStatus } = ApiClient();
    const { isMobile, deviceType } = useDeviceType()
    const InstapayPayerAccountRegex = /^([a-zA-Z0-9._]{3,30}@(instapay|demopay)|01[0125][0-9]{8})$/;
    const [formValidationErrors, setFormValidationError] = useState(null)
    const [showCollectionMethods, setShowCollectionMethods] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [showPayButton, setShowPayButton] = useState(true)
    const [collectionMethod, setCollectionMethod] = useState(null)
    const [payerAccount, setPayerAccount] = useState(null)
    const [authViewResponse, setAuthViewResponse] = useState(null)
    const [checkStatusIntervalId, setCheckStatusIntervalId] = useState(null)

    const handleCollectionMethodChange = (selected_method) => {
        setCollectionMethod(selected_method)
        setFormValidationError(null)
    }

    const handlePayerAccountChange = (e) => {
        setPayerAccount(e.target.value)
        setFormValidationError(null)
    }

    const validate = () => {
        setFormValidationError(null)
        if (!collectionMethod || collectionMethod == null) {
            setFormValidationError({ error_code: "general", message: "Please Choose Payment Collection Method" })
            return false
        }

        if (collectionMethod === InstapayCollectionMethods.CollectRequest.code && payerAccount == null) {
            setFormValidationError({ error_code: "payer_account", message: "IPN Field is required" })
            return false
        }


        if (collectionMethod === InstapayCollectionMethods.CollectRequest.code && !InstapayPayerAccountRegex.test(payerAccount)) {
            setFormValidationError({ error_code: "payer_account", message: "Invalid format. Use yourname@instapay or 01xxxxxxxxx." })
            return false
        }
        return true;
    } 

    const checkTransactionStatus = useCallback(() => {
        getAuthenticationStatus(payment_session_info.authToken, payment_session_info.sessionId, (responseDto) => {
            if (Object.hasOwn(responseDto, "succeeded") && responseDto["succeeded"]) {
            if (responseDto["status"] === "InProgress") {
                return;
            } else if (responseDto["status"] === "Successful") {
                clearInterval(checkStatusIntervalId);
                window.location.replace(payment_session_info.success_url);
            } else {
                clearInterval(checkStatusIntervalId);
                window.location.replace(payment_session_info.failure_url + '?error_message=DO_NOT_PROCEED');
            }
        }
        else if (this.ObjectContains(responseDto, "succeeded") && !responseDto["succeeded"]) {
            alert(responseDto["error_message"]);
        }
        else {
            alert("Something went wrong, try again later");
        }
        }, (error) => console.log(error));
    }, [getAuthenticationStatus, payment_session_info, checkStatusIntervalId])

    const onGetAuthViewSuccess = useCallback((response) => {
        if (response && !response.succeeded) {
            setFormValidationError({ error_code: "general", message: response.error_message })
            return;
        }
        if (!response.otpHtmlContent && collectionMethod !== InstapayCollectionMethods.CollectRequest.code) {
            setFormValidationError({ error_code: "general", message: "Error Payment with instapay" })
            return;
        }

        if (collectionMethod === InstapayCollectionMethods.IntentCall.code) {
            window.location.replace(response.otpHtmlContent)
            return;
        }

        onChangeTapsVisiability(false)
        setAuthViewResponse(response)
        let intervalId = setInterval(() => {
           checkTransactionStatus() 
        }, 5000);
        setCheckStatusIntervalId(intervalId)
        setShowCollectionMethods(false)
        setShowPayButton(false)
    }, [collectionMethod, onChangeTapsVisiability, checkTransactionStatus])


    const onGetAuthViewFailure = useCallback((error) => {
        setFormValidationError({ error_code: "general", message: JSON.stringify(error) })
    }, [])

    const handleFormSubmit = async (e) => {
        e.preventDefault()
        if (!validate()) {
            return;
        }
        let requestDto = {
            payment_method_code: PaymentMethodType.Instapay,
            session_id: payment_session_info.sessionId,
            instapay_collection_method: collectionMethod,
            payer_account: payerAccount,
        }

        if (isMobile) {
            requestDto['device_type'] = `${deviceType}-browser`
        }
        setIsSubmitting(true)
        await getAuthenticationView(requestDto, payment_session_info.authToken, onGetAuthViewSuccess, onGetAuthViewFailure);
    }
    return (
        <div className="row">
            {
                showCollectionMethods &&
                <Form>
                    <ul className="list-unstyled">
                        {
                            Object.entries(InstapayCollectionMethods).filter(([k,v]) => {
                                return !(!isMobile && v.code === InstapayCollectionMethods.IntentCall.code)
                            }).map(([key, instapayCollectionMethod]) => {
                                return (
                                    <li className="my-4 cursor-pointer" key={`method-${key}`}>
                                        <Form.Check type="radio"
                                            label={instapayCollectionMethod.label}
                                            id={`method-${instapayCollectionMethod.code}`}
                                            checked={collectionMethod === instapayCollectionMethod.code}
                                            onChange={() => handleCollectionMethodChange(instapayCollectionMethod.code)} />
                                        {
                                            instapayCollectionMethod.code === InstapayCollectionMethods.CollectRequest.code &&
                                            <div style={{ minHeight: '1px' }}>
                                                <Collapse in={collectionMethod === InstapayCollectionMethods.CollectRequest.code}>
                                                    <div id="ipn-collapse-field">
                                                        <Form.Control className={`mt-3 ${formValidationErrors && formValidationErrors.error_code === "payer_account" ? 'is-invalid' : ''}`}
                                                            onChange={handlePayerAccountChange}
                                                            type="text"
                                                            placeholder="Type your IPN" />

                                                        {
                                                            formValidationErrors && formValidationErrors.error_code === "payer_account" &&
                                                            <div className="invalid-feedback d-block">{formValidationErrors.message}</div>
                                                        }
                                                    </div>
                                                </Collapse>
                                            </div>
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul>
                    {formValidationErrors && formValidationErrors.error_code === 'general' &&
                        <p style={{ fontWeight: 'bold' }} className="text-center text-danger">{formValidationErrors.message}</p>
                    }
                    <div className="text-center">
                        {
                            showPayButton && <button className="btn btn-md primary-btn pl-4 pr-4"
                                disabled={isSubmitting}
                                style={{ width: "50%" }}
                                onClick={handleFormSubmit}>
                                Pay {payment_session_info?.should_show_amount === true && payment_session_info?.amount_to_pay !== null &&
                                    `${payment_session_info?.amount_to_pay.toFixed(2)} ${payment_session_info?.currency}`}
                            </button>
                        }
                    </div>
                </Form>
            }

            {authViewResponse && collectionMethod === InstapayCollectionMethods.QR.code && <InstapayQrCode qrCode={authViewResponse.otpHtmlContent} />}
            {authViewResponse && collectionMethod === InstapayCollectionMethods.PaymentLink.code && <PaymentLink paymentLink={authViewResponse.otpHtmlContent} />}
            {authViewResponse && collectionMethod === InstapayCollectionMethods.CollectRequest.code && <CollectRequest payerAccount={payerAccount} />}


            <div className="mt-2">
                <PoweredByBox />
            </div>

        </div>
    )
}

export default InstapayPaymentForm;